import cookie from 'cookie-utils-js';
import { sleep, getStorageData } from '@/utils/util';
import { getUserInfo } from '@/api/user';

const resetState = {
	nickname: '',
	userId: '',
	balance: 0,
	credits: 0,
	avatar: ''
};

const actions = {
	async updateUserInfo({ commit, state, rootState }, payload) {
		const appid = cookie.get('App-Id') || '1692d9cb170b471093e4922d67402264';
    const token = cookie.get('token') || '1e41ee5575df75c3ed53c5fa0f8dc7ae';

		if (!token || !appid) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
			return;
		}

		try {
			const res = await getUserInfo({
        appid,
        token
      });

			if (res.code === 0) {
				commit('UPDATE_USER_INFO', {
					nickname: res.data.nickname,
					userId: res.data.fake_id,
					balance: res.data.balance,
					credits: res.data.credits,
					avatar: res.data.avatar
				});
				return;
			}

			commit('UPDATE_USER_INFO', {
				...resetState
			});
		}
		catch(err) {
			commit('UPDATE_USER_INFO', {
				...resetState
			});
		}
	},
}

export default actions;
